import { TransformConvertorBase } from './transform.convertor';
import { Transformation } from 'app/model/dataflow/transformation';
import { GuardTransformation } from 'app/model/dataflow/guardtransformation';
import { IResourceContext } from 'shell-models-lib';

export class GuardConvertor extends TransformConvertorBase {
    private get guardTransformation(): GuardTransformation {
        return this.transformation as GuardTransformation;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);
        super.postConvert();
        return this.guardTransformation;
    }
}
